import type { ReactNode } from 'react';
import { Navigate } from 'react-router';
import { RequireAuth } from '@/routes/guards';
import { useAuth } from '@/contexts/Authentication';
import { isEnvironmentStatus } from '../../constants';

/**
 * Guarda do ambiente do médico: exige perfil DOCTOR (+2FA, pelo RequireAuth) e credenciamento concluído (RN-83).
 * Quem ainda está no credenciamento cai no onboarding/status (T-32).
 */
export default function RequireDoctor({ children, released }: { children: ReactNode; released?: boolean }) {
  return (
    <RequireAuth roles={['DOCTOR']}>
      {released ? <ReleasedOnly>{children}</ReleasedOnly> : children}
    </RequireAuth>
  );
}

function ReleasedOnly({ children }: { children: ReactNode }) {
  const { me } = useAuth();
  if (!isEnvironmentStatus(me?.doctor?.credentialStatus)) return <Navigate to="/medico/credenciamento" replace />;
  return <>{children}</>;
}
